import ScoreCardRow from './ScoreCardRow';

export default ScoreCardRow;


// WEBPACK FOOTER //
// ./src/features/score-card/components/score-cards-row/index.js